<template>
  <div class="mod-org__post-new">
    <el-form :inline="true" :model="dataForm" :rules="dataRule" size="medium" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" label-width="130px">
      <el-form-item prop="postName" label="岗位名称">
        <el-input v-model="dataForm.postName" placeholder="" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="postDescribe" label="岗位描述">
        <el-input v-model="dataForm.postDescribe" placeholder="" :maxlength="20"></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="4">
          <div class="auth-list">
            <div class="auth-list-head">权限模块</div>
            <div v-for="item in authList" :key="item.menuId" class="auth-list-content" @click="chooesdAuth(item)">{{item.menuName}}</div>
          </div>
        </el-col>
        <el-col :span="20">
          <el-card class="box-card">
            <div class="box-card-body">
              <el-col :span="11">
                <div>权限列表</div>
                <el-table
                  :data="dataList1"
                  v-show="dataList1"
                  @selection-change="choosedListHandle"
                  border
                  style="width: 100%; max-width: 100%;">
                  <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                  <el-table-column type="index" label="序号" header-align="center" align="center" width="50"></el-table-column>
                  <el-table-column prop="packageName" label="权限名称" header-align="center" align="center"></el-table-column>
                  <el-table-column prop="remarks" label="权限描述" header-align="center" align="center"></el-table-column>
                </el-table>
              </el-col>
              <el-col :span="2" class="box-card-body-opt">
                <div><el-button icon="el-icon-right" @click="addAuth" circle v-show="choosedDataList1.length"></el-button></div>
                <div><el-button icon="el-icon-back" @click="reduceAuth" circle v-show="choosedDataList2.length"></el-button></div>
              </el-col>
              <el-col :span="11">
                <div>已选择</div>
                <el-table
                  :data="dataList2"
                  border
                  style="width: 100%; max-width: 100%;">
                  <!-- @selection-change="cancleListHandle" -->
                  <!-- <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column> -->
                  <el-table-column label="操作" header-align="center" align="center" width="50">
                    <template slot-scope="scope">
                      <i class="el-icon-remove-outline" @click="deleteChoosedList(scope.$index)"></i>
                    </template>
                  </el-table-column>
                  <el-table-column type="index" label="序号" header-align="center" align="center" width="50"></el-table-column>
                  <el-table-column prop="packageName" label="权限名称" header-align="center" align="center"></el-table-column>
                  <el-table-column prop="remarks" label="权限描述" header-align="center" align="center"></el-table-column>
                </el-table>
              </el-col>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <el-row class="align-right">
      <el-button type="primary" :loading="dataListLoading" @click="dataFormSubmitHandle()">提交</el-button>
      <el-button :loading="dataListLoading" @click="cancleHandle()">取消</el-button>
    </el-row>
  </div>
</template>
<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      dataListLoading: false,
      authList: [],
      dataList1: [],
      choosedDataList1: [],
      dataList2: [],
      choosedDataList2: [],
      dataForm: {
        postName: '',
        postDescribe: '',
        sort: 0
      }
    }
  },
  computed: {
    postId () {
      return this.$route.query.pid || ''
    },
    dataRule () {
      return {
        postName: [
          { required: true, message: '岗位名称必填', trigger: 'blur' }
        ],
        postDescribe: [
          { required: true, message: '岗位描述必填', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    postId (val) {
      this.authList = []
      this.dataList1 = []
      this.choosedDataList1 = []
      this.dataList2 = []
      this.choosedDataList2 = []
      this.dataForm.name = ''
      this.dataForm.postDescribe = ''
      if (val) {
        this.getInfo()
      }
    }
  },
  mounted () {
    if (this.postId) {
      this.dataForm.postId = this.postId
      this.getInfo()
    }
    this.getAuthList()
  },
  methods: {
    // 获取岗位详情
    getInfo () {
      this.$http.get(`/front/consumer/custorg/postInfo/${this.postId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.dataForm.postName = res.data.postName
          this.dataForm.postDescribe = res.data.postDescribe
          this.dataForm.sort = res.data.sort
          this.dataList2 = res.data.authMenuList
        }).catch(() => {})
    },
    getAuthList () {
      this.authList = []
      this.$http.get(`/front/consumer/custorg/postAuth/list/${window.SITE_CONFIG.appCode}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
            // this.$message.error(res.message)
          }
          this.authList = res.data || []
        }).catch(() => {})
    },
    // 选择权限模块
    chooesdAuth (authItem) {
      this.choosedDataList1 = []
      this.dataList1 = authItem.authMenuList || []
    },
    // 权限列表选中
    choosedListHandle (val) {
      this.choosedDataList1 = val
    },
    // 已选择的取消
    cancleListHandle (val) {
      this.choosedDataList2 = val
    },
    // 将权限列表增加到已选择的
    addAuth () {
      this.choosedDataList1.forEach(orgItem => {
        if (this.dataList2.findIndex(item => {
          return item.packageId === orgItem.packageId
        }) === -1) {
          this.dataList2.push(orgItem)
        }
      })
    },
    deleteChoosedList (index) {
      if (index > -1) {
        this.dataList2.splice(index, 1)
      }
    },
    // 取消已选择的权限列表
    reduceAuth () {
      this.choosedDataList2.forEach(orgItem => {
        let index = this.dataList2.findIndex(item => {
          return item.packageId === orgItem.packageId
        })
        if (index > -1) {
          this.dataList2.splice(index, 1)
        }
      })
    },
    // 提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let authMenuList = []
        authMenuList = this.dataList2.filter(item => {
          return this.choosedDataList2.length === 0 || this.choosedDataList2.findIndex(ii => {
            return ii.packageId === item.packageId
          }) === -1
        }).map(item => {
          return {
            packageId: item.packageId
          }
        })
        if (authMenuList.length === 0) {
          return this.$message.error('已选择权限列表不能为空')
        }
        this.$http.post(`/front/consumer/custorg/${!this.dataForm.postId ? 'savePost' : 'updatePost'}`, {
          ...this.dataForm,
          companyId: this.$store.state.user.defaultCompanyId,
          postId: this.postId,
          authMenuList: authMenuList
        })
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success(this.$t('prompt.success'))
            this.$router.go(-1)
          }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false }),
    // 取消
    cancleHandle () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang='scss' scoped>
.mod-org__post-new{
  .auth-list{
    margin-right: 10px;
    display: flex;
    flex-direction: column;
    border: 1px solid #eee;
    .auth-list-head{
      line-height: 40px;
      background: #f5f5f5;
      padding-left: 14px;
    }
    .auth-list-content{
      cursor: pointer;
      color: #333333;
      line-height: 50px;
      padding-left: 14px;
    }
  }
  .box-card{
    padding-bottom: 10px;
    .box-card-body{
      display: flex;
      align-items: center;
      .box-card-body-opt{
        text-align: center;
      }
    }
  }
}
</style>
